var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRotate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 11,
    cy: 11,
    r: 11
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-20.5%",
    y: "-20.5%",
    width: "140.9%",
    height: "140.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.14 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u8F91\\u5668\\u6539\\u7248",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u66FF\\u6362\\u6587\\u5B57",
    transform: "translate(-986.000000, -624.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(751.000000, 355.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(238.000000, 272.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval-2"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u5FAA\\u73AF",
    transform: "translate(3.000000, 3.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    opacity: 0,
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.62457255,13.5798009 C6.59408122,13.5798009 6.56320616,13.5763312 6.53233109,13.5688003 C4.46736313,13.0753269 2.8138602,11.5046958 2.21695291,9.46964358 C1.39579766,6.67154069 2.70404666,3.72405109 5.32770781,2.4613392 C5.52418261,2.36716305 5.76077419,2.44937931 5.85514222,2.64612592 C5.94989398,2.84277659 5.86710211,3.07898444 5.67045144,3.17365625 C3.3970648,4.26769848 2.26365725,6.8219667 2.97539869,9.24715442 C3.49279189,11.0108546 4.92610811,12.3720757 6.71606252,12.7999296 C6.92833459,12.8506792 7.05938175,13.0639426 7.00861617,13.2764226 C6.96518959,13.4578196 6.80328338,13.5798009 6.62457255,13.5798009 Z M7.42623702,13.7361109 C7.27165383,13.7361109 7.12498527,13.6450207 7.06149231,13.4937153 L6.26619153,11.5949226 C6.1818647,11.3935392 6.27661647,11.1619522 6.47807988,11.0776094 C6.67898366,10.9932825 6.91076252,11.0880343 6.99528122,11.2894178 L7.790582,13.1880185 C7.87490883,13.3894979 7.78015706,13.6210849 7.57869366,13.7052358 C7.52890341,13.7260697 7.47719447,13.7361109 7.42623702,13.7361109 Z M5.89893652,15.1163431 C5.79107364,15.1163431 5.68356255,15.072341 5.60559939,14.9858876 C5.45910672,14.8241732 5.47186606,14.5740548 5.6337723,14.42777 L7.16107278,13.0475378 C7.32317088,12.901269 7.57309742,12.9139963 7.71919038,13.0757267 C7.86566706,13.2378408 7.8529237,13.4875595 7.69101747,13.6340202 L6.16371698,15.0142683 C6.08807228,15.08259 5.99330455,15.1163431 5.89893652,15.1163431 Z M10.5010962,13.5110955 C10.3540599,13.5110955 10.2127957,13.4284795 10.1448418,13.2870394 C10.05009,13.0903727 10.1328819,12.8541649 10.3295486,12.759589 C12.6029352,11.6654508 13.7363268,9.11118262 13.0246173,6.68602687 C12.5072241,4.92231067 11.0738919,3.56099364 9.28395348,3.13323567 C9.07168141,3.08248608 8.94061827,2.86922267 8.99138384,2.65695059 C9.04232531,2.44466253 9.25576459,2.31439884 9.46766892,2.36447689 C11.5326209,2.85783839 13.1861558,4.42856544 13.7830471,6.46350575 C14.6041864,9.26160862 13.2959374,12.2092102 10.6722762,13.4717142 C10.6170816,13.4983521 10.5586093,13.5110955 10.5010962,13.5110955 Z M9.36941553,4.88631908 C9.21483234,4.88631908 9.06816378,4.79513291 9.00467083,4.64373155 L8.20919417,2.74522673 C8.12486734,2.54374734 8.21960311,2.31216036 8.42108252,2.22781753 C8.62179444,2.14377852 8.85378114,2.23833839 8.93829984,2.43962592 L9.7337925,4.33824266 C9.81811933,4.53961013 9.72338356,4.77121311 9.52190416,4.85553992 C9.47209792,4.87637381 9.42037298,4.88631908 9.36941553,4.88631908 Z M8.57392287,2.98762239 C8.46604402,2.98762239 8.35854891,2.94371616 8.28058575,2.8573587 C8.13410906,2.69543648 8.14685242,2.44552592 8.30875866,2.29914517 L9.83605914,0.918896984 C9.99817323,0.772420297 10.2480998,0.785259594 10.3941607,0.947165812 C10.5406534,1.10908803 10.5278941,1.35899859 10.3659878,1.50539533 L8.83868736,2.88562753 C8.76304266,2.95393323 8.66830689,2.98762239 8.57392287,2.98762239 Z",
    id: "Shape"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotate);
export default __webpack_public_path__ + "static/media/rotate.ffb1763313add9b51dbbac83cfb13ba6.svg";
export { ForwardRef as ReactComponent };